import React, { memo, useCallback } from 'react';
import { CustomTableCell } from '../../styles';
import { CustomTableCellForAccount, CustomTableCellRedirectToVoucher } from './tableCell';
import { TableRow, Button } from '@mui/material';
import { formatNumber, TRANSACTION_CONFIG } from '../../../../utils/common';
import { useSetOffModal, SetOffModal } from '../../../../features/LedgerTransactions';
import { formatUnixTimestamp } from '../../../../library';

export const CustomTableRow = memo(
  ({
    data,
    index,
    handleTransationModal,
    accountDetails,
    accountTypeFlag,
    showLinkedInvoiceVsReceipt = false,
    fetchData,
    filters,
    rowsperpage,
    openingBalanceSec,
    headCell = [],
  }) => {
    const { isOpen, transactionData, openModal: openSetOffModal, closeModal: closeSetOffModal } = useSetOffModal();

    // Helper function to get cell width by id
    const getCellWidth = (cellId) => {
      const cell = headCell.find((hc) => hc.id === cellId);
      if (cell) {
        const width = cell.width;
        return { width, minWidth: cell.minWidth || width, maxWidth: width };
      }
      return {};
    };

    const handleTransactionClick = useCallback(() => {
      handleTransationModal(data.oppositeaccountid);
    }, [data]);

    const handleSetOffClick = useCallback(() => {
      const voucherType = data.transactiontype;
      const config = TRANSACTION_CONFIG[voucherType] || undefined;
      let voucherId = config?.getTransactionId(data);
      let voucherNumber = data.vouchernumber;
      let accountid = null;
      if(data.transactiontype === 'OpeningBalance'){
        voucherId = data.transactionid;
        voucherNumber = 'OpeningBalance'
        accountid = data.accountid;
      }
      openSetOffModal(voucherType, voucherId, voucherNumber,accountid );
    }, [data, openSetOffModal]);

    const hasDebitValue = accountTypeFlag === 1 && Number(data.totaldebitamount || 0);
    const hasCreditValue = accountTypeFlag === 2 && Number(data?.totalcreditamount || 0);
    const isOpeningBalance = data.transactiontype === 'OpeningBalance';
    const isOpeningBalanceFilter =
      isOpeningBalance && openingBalanceSec && Number(filters?.start) === Number(openingBalanceSec);
    const isOpeningBalanceWithValidBalance =
      isOpeningBalanceFilter &&
      ((accountTypeFlag === 1 && Number(data?.balance || 0) > 0) ||
        (accountTypeFlag === 2 && Number(data?.balance || 0) > 0));
        const canRenderSetOffButton =
        (!isOpeningBalance && (hasDebitValue || hasCreditValue)) || isOpeningBalanceWithValidBalance;


    return (
      <>
        <TableRow className="noTableCellBorder" key={index + 'r'}>
          <CustomTableCell sx={getCellWidth('Date')}>{formatUnixTimestamp(data.enteredtimestamp)}</CustomTableCell>
          <CustomTableCellForAccount 
            onClick={handleTransactionClick} 
            data={data} 
            accountDetails={accountDetails}
            sx={getCellWidth('Account')}
          />
          <CustomTableCell sx={getCellWidth('VoucherType')}>
            {data.transactiontype != 'OpeningBalance' ? (data.transactiontype == 'ManualJournal' ? 'Journal' : data.transactiontype) : ''}
          </CustomTableCell>
          <CustomTableCellRedirectToVoucher data={data} type={data.transactiontype} sx={getCellWidth('VoucherNumber')}>
            {data.transactiontype == 'OpeningBalance' ? '' : data.vouchernumber}
          </CustomTableCellRedirectToVoucher>
          <CustomTableCell align="right" sx={getCellWidth('debit')}>
            {data.transactiontype != 'OpeningBalance' ? formatNumber(data.totaldebitamount, false, true) : ''}
          </CustomTableCell>
          <CustomTableCell align="right" sx={getCellWidth('credit')}>
            {data.transactiontype != 'OpeningBalance' ? formatNumber(data.totalcreditamount, false, true) : ''}
          </CustomTableCell>
          <CustomTableCell align="right" sx={getCellWidth('Balance')}>{formatNumber(data?.balance, true, true, data.balancesign)}</CustomTableCell>
          {showLinkedInvoiceVsReceipt && (
            <>
              <CustomTableCell align="center" sx={getCellWidth('setOff')}>
                {canRenderSetOffButton ? (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleSetOffClick}
                    sx={{
                      minWidth: '80px',
                      fontSize: '0.75rem',
                      py: 0.5,
                      px: 1,
                    }}
                  >
                    Set-Off
                  </Button>
                ) : (
                  ''
                )}
              </CustomTableCell>
              <CustomTableCell align="right" sx={getCellWidth('PendingSetoff')}>
                {formatNumber(data?.setoffbalance || 0, false, true)}
              </CustomTableCell>
            </>
          )}
          <CustomTableCell align="left" sx={getCellWidth('SetoffRemarks')}>
            {!showLinkedInvoiceVsReceipt
              ? data?.comments?.replace(/\*\*/g, '\n') || ''
              : data?.comments?.replace(/\*\*/g, '\n') + ' ' + (data?.setoffremarks || '')}
          </CustomTableCell>
        </TableRow>
        {isOpen && (
          <SetOffModal
            open={isOpen}
            onClose={closeSetOffModal}
            voucherType={transactionData?.voucherType}
            voucherId={transactionData?.voucherId}
            voucherNumber={transactionData?.voucherNumber}
            accountid={transactionData?.accountid}
            onSetOffSuccess={() => {
              // Refetch data with filters preserved but reset page to 0
              if (fetchData && filters) {
                fetchData({ 
                  reset: true, 
                  start: filters.start, 
                  end: filters.end, 
                  limit: 0, 
                  from: rowsperpage 
                });
              }
            }}
          />
        )}
      </>
    );
  }
);

export default TableRow;
